import { View } from "@aws-amplify/ui-react";
import React from "react";

export default function NotificationBadge({
  placement,
}: {
  placement: "left" | "right";
}) {
  return (
    <View
      className={"bouncy-small"}
      position={"absolute"}
      top={"-7px"}
      left={placement === "left" ? "-5px" : "auto"}
      right={placement === "right" ? "-5px" : "auto"}
      width={"14px"}
      border={"1px solid"}
      borderColor={"yellow.80"}
      backgroundColor={"yellow.60"}
      boxShadow={"0 1px 1px  rgba(0, 0, 0, 0.2)"}
      borderRadius={"20px"}
      style={{ aspectRatio: "1/1" }}
    ></View>
  );
}
